var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'app-fixed' : _vm.mobileMenuVisible },attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('Navbar',{on:{"mobileMenuToggled":_vm.mobileMenuToggle}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }